import { render, staticRenderFns } from "./MixForm.vue?vue&type=template&id=36ef8247&scoped=true"
import script from "./MixForm.vue?vue&type=script&lang=js"
export * from "./MixForm.vue?vue&type=script&lang=js"
import style0 from "./MixForm.vue?vue&type=style&index=0&id=36ef8247&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef8247",
  null
  
)

export default component.exports